import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import VideoEditing from './videoediting';

export default class Video extends Plugin {
  static get requires() {
    return [VideoEditing];
  }

  static get pluginName() {
    return 'Video';
  }
}